import { collectStringLeaves, applyTranslations } from './translation-json';
import { localeFromPath } from './locale';
import { translateStrings } from './translate';
import { scoreEnglishComparison } from './english-comparison-score';

/**
 * Google-translate locale JSON to English and score word match vs en.json master.
 * @param {object} options
 * @param {Function} options.axios
 * @param {string} options.localePath
 * @param {*} options.localeContent
 * @param {*} options.englishContent
 * @returns {Promise<ReturnType<typeof scoreEnglishComparison>>}
 */
export async function auditLocaleFileAgainstEnglish({
  axios,
  bucket,
  localePath,
  localeContent,
  englishContent
}) {
  if (
    localeContent === null ||
    localeContent === undefined ||
    englishContent === null ||
    englishContent === undefined
  ) {
    return null;
  }

  if (typeof localeContent === 'string' || typeof englishContent === 'string') {
    return null;
  }

  const entries = collectStringLeaves(localeContent);
  if (!entries.length) {
    return scoreEnglishComparison(localeContent, englishContent);
  }

  const locale = localeFromPath(localePath);
  if (!locale) {
    throw new Error('Could not detect locale from file path');
  }

  const texts = entries.map(entry => entry.value);
  const translations = await translateStrings(axios, texts, {
    source: locale,
    target: 'en',
    mode: 'compare',
    bucket
  });

  const machinePreview = applyTranslations(localeContent, entries, translations);
  return scoreEnglishComparison(machinePreview, englishContent);
}
